// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--XOM3O","tableModule":"tableModule--DJ4yq","specialTable":"specialTable--Bbm8Z","markerAnimationScale":"markerAnimationScale--ku4pO"};